import React, { useContext, useMemo } from "react";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import { CityContext } from "../context/CityContext";
import useShop from "./use-shop";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekday);
dayjs.extend(isBetween);

type WorkingHours = {
  openingTime: string;
  closingTime: string;
  reverse?: boolean;
};

type ClodesText = string | JSX.Element;

const TIMEZONE = "Asia/Yekaterinburg";
const EXTENDED_DAYS = [4, 5]; // Friday, Sunday

const useWorkingHours = (): {
  isClosed: boolean;
  closedText: ClodesText;
  getWorkingHours;
  cityName;
} => {
  const { cityName } = useContext(CityContext);

  const currentDate = dayjs().tz(TIMEZONE);
  const currentWeekday = currentDate.weekday();

  const getWorkingHours = (): WorkingHours => {
    return {
      openingTime: "08:00:00+05:00",
      closingTime: "00:00:00+05:00",
    };
  };

  const { openingTime, closingTime, reverse } = getWorkingHours();

  const today = currentDate.format("YYYY-MM-DD");
  const openingTimeWithDay = dayjs(`${today}T${openingTime}`);
  const closingTimeWithDay = dayjs(`${today}T${closingTime}`);

  const { workTimeStart, workTimeEnd, workTimeSet } = useShop();

  const isClosed = useMemo(() => {
    const isBeetween = currentDate.isBetween(
      openingTimeWithDay,
      closingTimeWithDay
    );
    return reverse ? !isBeetween : isBeetween;
  }, [closingTimeWithDay, openingTimeWithDay, reverse]);

  const getClosedText = (): ClodesText => {
    return <>Заказы принимаем с&nbsp;8:00 &nbsp;до&nbsp;24:00</>;
  };

  const closedText = getClosedText();

  return { isClosed, closedText, getWorkingHours, cityName };
};

export default useWorkingHours;
